export enum SinkInfoModalStep {
  SINK_INFO = 'SINK_INFO',
  CHIP_MINIMIZER = 'CHIP_MINIMIZER',
}
